import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.561 4.409l-3.97-3.97C13.298.146 12.914 0 12.53 0s-.768.146-1.061.439L6.909 5H0l6.076 6.076L.211 16.94a.6.6 0 0 0 .848.848l5.864-5.864L13 18v-6.909l4.561-4.561a1.501 1.501 0 0 0 0-2.121zm-.849 1.273L11.8 10.594v4.509L2.897 6.2h4.509l4.912-4.912c.073-.073.155-.088.212-.088s.14.015.212.088l3.97 3.97c.073.073.088.155.088.212s-.015.139-.088.212z" />
  </svg>
);

export default SvgComponent;
